export default __webpack_public_path__ + "static/media/edit.fb3d6371.svg";